import { render } from "./user_dashboard.vue?vue&type=template&id=388e8662"
import script from "./user_dashboard.vue?vue&type=script&lang=js"
export * from "./user_dashboard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__